var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHousekeepingDoorDirty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1034_9136",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#62BA60"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1034_9136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.006 19.304H7.46875V4.69531H16.006V19.304ZM14.8586 11.802C14.8586 11.6202 14.8638 11.4383 14.8573 11.257C14.8489 11.0058 14.7171 10.8464 14.4593 10.8477C14.2158 10.8489 14.0866 11.0051 14.0821 11.2416C14.0743 11.6157 14.0736 11.9903 14.0821 12.3637C14.0873 12.5983 14.2197 12.759 14.46 12.7596C14.7138 12.7603 14.847 12.5964 14.8567 12.347C14.8638 12.1658 14.858 11.9839 14.858 11.802H14.8586Z",
    fill: "url(#paint0_linear_1034_9136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.67956 19.3043H5.89453V18.9599C5.89453 14.1295 5.89453 9.29851 5.89453 4.46814C5.89518 3.5729 6.34776 3.12109 7.24317 3.12109C10.2404 3.12109 13.2383 3.12109 16.2356 3.12109C17.1187 3.12109 17.5836 3.5729 17.5836 4.43537C17.5842 9.28758 17.5836 14.1392 17.5836 18.9914V19.2973H16.7985C16.7985 19.1649 16.7985 19.0402 16.7985 18.9149C16.7985 14.1269 16.7985 9.33964 16.7985 4.55169C16.7985 3.97521 16.7219 3.89809 16.1538 3.89745C13.2104 3.89745 10.267 3.89745 7.32368 3.89745C6.75553 3.89745 6.67891 3.97521 6.67891 4.55105C6.67891 9.31714 6.67891 14.0839 6.67891 18.85C6.67891 18.9888 6.67891 19.1276 6.67891 19.3037L6.67956 19.3043Z",
    fill: "url(#paint1_linear_1034_9136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7062 20.8667C9.58679 20.8667 7.46806 20.8667 5.34868 20.8667C5.25128 20.8667 5.12337 20.9008 5.06363 20.8532C4.93377 20.7498 4.75391 20.6045 4.75391 20.476C4.75391 20.35 4.93377 20.2016 5.06623 20.1058C5.13765 20.0544 5.27596 20.0904 5.38375 20.0904C9.62185 20.0904 13.86 20.0904 18.0981 20.0904C18.1305 20.0904 18.163 20.0904 18.1955 20.0904C18.5734 20.0936 18.7513 20.2176 18.75 20.4785C18.7487 20.7343 18.5617 20.8667 18.1929 20.8667C16.0306 20.8667 13.8684 20.8667 11.7062 20.8667Z",
    fill: "url(#paint2_linear_1034_9136)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1034_9136",
    x1: 11.7374,
    y1: 4.69531,
    x2: 11.7374,
    y2: 19.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1034_9136",
    x1: 11.7392,
    y1: 3.12109,
    x2: 11.7392,
    y2: 19.3043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1034_9136",
    x1: 11.7519,
    y1: 20.0781,
    x2: 11.7519,
    y2: 20.8785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousekeepingDoorDirty);
export default __webpack_public_path__ + "static/media/housekeeping_door_dirty.30548ac22074820bc263c52e1fc7bdf1.svg";
export { ForwardRef as ReactComponent };